// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uUrEV,.ql8vL{font-family:"Inter",sans-serif;border:2px solid rgba(0,0,0,0);border-radius:.9375rem;background-color:#0078d4;color:#fff;font-size:15px;font-weight:600;padding:13px 25px;cursor:pointer;text-transform:none;min-width:220px}
.qPlBF{font-family:"Inter",sans-serif}
._oC8n{background-color:#fff;border-radius:16px 16px 0 0;font-family:"Inter",sans-serif;top:-8px;position:relative;padding-top:48px;padding-bottom:24px;-webkit-box-shadow:0 -4px 20px -4px rgba(0,0,0,.04);box-shadow:0 -4px 20px -4px rgba(0,0,0,.04)}
.UFRNk{font-weight:700;font-size:28px;color:#0f172a;letter-spacing:-0.5px;line-height:1.3;margin-bottom:0}
.HEkV8{margin-top:12px;font-weight:400;font-size:16px;color:#64748b;letter-spacing:-0.1px;line-height:1.6;margin-left:auto;margin-right:auto}
.ffioN{padding-top:32px !important;padding-bottom:16px !important}
.wi510{color:#334155}
.X_lLJ{border-collapse:separate;border-spacing:0;border-radius:8px;overflow:hidden}
.X_lLJ tbody{--bs-table-bg: #F1F5F9}
.X_lLJ tbody tr:first-child td:first-child{border-top-left-radius:8px}
.X_lLJ tbody tr:first-child td:last-child{border-top-right-radius:8px}
.X_lLJ tbody tr:last-child td:first-child{border-bottom-left-radius:8px}
.X_lLJ tbody tr:last-child td:last-child{border-bottom-right-radius:8px}
.Cs6WR{padding:10px 12px;border-radius:8px;font-weight:400;font-size:14px;color:hsl(215,20.2247191011%,60.0980392157%)}
.fZzMN{padding:10px 12px;background-color:#fff;border-radius:8px;border:1px solid #e2e8f0;font-weight:400;font-size:14px;color:hsl(215,20.2247191011%,60.0980392157%)}
.Soxyv{font-weight:600;font-size:14px;min-width:150px;color:#1e293b;letter-spacing:.5px;text-transform:uppercase;padding-bottom:8px}
.K8uTQ{width:100%;overflow-x:auto}
.K8uTQ .X_lLJ{width:100%}
.P0TBh{min-width:110px;width:110px}
.DTqCk{min-width:0;word-break:break-all}
.ql8vL{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;padding:4px 16px !important;font-size:13px !important;border-radius:6px !important;min-width:70px !important}
.ql8vL:hover,.ql8vL:focus{border:2px solid #0078d4 !important;background-color:rgba(0,0,0,0) !important;color:#0078d4 !important}
.qPlBF{background-color:#fff;padding-top:24px;border-radius:12px}
.aLrNz{font-size:22px;font-weight:700}
.sHjx0{color:#94a3b8;font-size:18px;font-weight:500}
.x0OUM{border-radius:12px;border:1px solid #e2e8f0;padding:25px}
.wlztb{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:16px}
.RolZ1{display:grid;grid-template-columns:99px minmax(0, 1fr) auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-column-gap:3rem;-moz-column-gap:3rem;column-gap:3rem;min-height:96px;width:100%;margin:0}
.b40PE{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:0}
.Ui4jo{min-width:0}
.jmIS6{justify-self:end}
.H0zb1,.y06Y1{color:#64748b;font-size:40px}
.vpsxP{min-width:220px}
.EZD4B{color:#64748b;font-size:16px}
.TWWXg{background:none;border:none;padding:0;color:#0078d4;font-weight:500;cursor:pointer;text-decoration:underline}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonBlue": `uUrEV`,
	"copyButton": `ql8vL`,
	"baseContainer": `qPlBF`,
	"formContainer": `_oC8n`,
	"title": `UFRNk`,
	"subtitle": `HEkV8`,
	"dnsStepContainer": `ffioN`,
	"textContainer": `wi510`,
	"manualTable": `X_lLJ`,
	"firstTableCell": `Cs6WR`,
	"tableCell": `fZzMN`,
	"tableHeader": `Soxyv`,
	"tableWrap": `K8uTQ`,
	"typeColumn": `P0TBh`,
	"cellText": `DTqCk`,
	"elementTitle": `aLrNz`,
	"elementSubTitle": `sHjx0`,
	"optionCardContainer": `x0OUM`,
	"optionsStack": `wlztb`,
	"optionCard": `RolZ1`,
	"leadingArea": `b40PE`,
	"textCol": `Ui4jo`,
	"actionCol": `jmIS6`,
	"emailIcon": `H0zb1`,
	"settingsIcon": `y06Y1`,
	"actionButton": `vpsxP`,
	"alternativeText": `EZD4B`,
	"alternativeLink": `TWWXg`
};
module.exports = ___CSS_LOADER_EXPORT___;
